import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mic, Sparkles, Upload, ShieldCheck, BarChart3, FileText, ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";

export function AskField({ compact = false }) {
  const { t } = useI18n();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [value, setValue] = useState("");

  const gate = (path, state) => {
    if (!user) { navigate("/register"); return; }
    navigate(path, state ? { state } : undefined);
  };

  const submit = (e) => {
    e?.preventDefault();
    if (!value.trim()) { gate("/chat"); return; }
    gate("/chat", { initial: value.trim() });
  };

  const actions = [
    { icon: Mic, label: t("ask_ai"), primary: true, onClick: () => submit() },
    { icon: Upload, label: t("upload_policy"), onClick: () => gate("/documents", { openUpload: true }) },
    { icon: ShieldCheck, label: t("check_protection"), onClick: () => gate("/protection") },
    { icon: BarChart3, label: t("build_budget"), onClick: () => gate("/budget") },
    { icon: FileText, label: t("explain_doc"), onClick: () => gate("/documents", { openUpload: true }) },
  ];

  return (
    <div className="w-full">
      <form onSubmit={submit} className="rounded-3xl bg-white border border-slate-100 card-shadow-lg p-2.5">
        <div className="relative">
          <textarea
            data-testid="ask-input"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) submit(e); }}
            rows={compact ? 2 : 2}
            placeholder={t("ask_placeholder")}
            className="w-full resize-none rounded-2xl bg-transparent px-4 py-3 pr-16 text-base text-navy placeholder:text-slate-400 focus:outline-none"
          />
          <button type="button" data-testid="ask-mic-btn" onClick={() => gate("/voice")}
            className="absolute right-3 top-1/2 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full border border-slate-200 bg-white text-brandblue hover:bg-blue-50 transition-colors">
            <Mic className="h-5 w-5" />
          </button>
        </div>
      </form>

      <div className="mt-4 flex flex-wrap gap-3">
        {actions.map((a) => (
          <button key={a.label} data-testid={`action-${a.label}`} onClick={a.onClick}
            className={`inline-flex items-center gap-2 rounded-2xl px-4 py-3 text-sm font-semibold transition-all ${
              a.primary
                ? "brand-gradient text-white card-shadow hover:opacity-90"
                : "bg-white text-navy border border-slate-100 card-shadow hover:-translate-y-0.5"
            }`}>
            <a.icon className="h-4 w-4" /> {a.label}
          </button>
        ))}
      </div>
    </div>
  );
}
